<script>
    export let data;
    let moving = 'start';
    /**
     *
     */
    function bntFun() {
        if (moving == 'start') {
            moving = 'start-slide';
        } else {
            moving = 'start';
        }
    }
</script>

<section>
    <div class="desktop" style="position: relative;">
        <div class="border-div" />
        <div class="hero-div">
            <p class="hero-text">650+ Companies</p>
        </div>
        <div class="raised-div">
            <p class="hero-text">7000+ New Jobs</p>
        </div>
        <div class="slider">
            {#each data as data}
                <div class="sli {moving}">
                    <div style="width:{data.div_width};">
                        <div
                            class="slider-img"
                            style="width:{data.logo_width};"
                        >
                            <img src={data.image} alt="" width="100%" />
                        </div>
                        <div class="data-part">
                            <p class="name-text" style="color:
                            rgba(0, 32, 75, 1);
                            font-weight:500;">{data.person_name}</p>
                            <p class="logo-text">{data.company_name}</p>
                        </div>
                    </div>
                </div>
            {/each}
            <div
                class="next-btn"
                style="position: absolute;top: 14.5vw;left: 31.217vw;width: 2.05vw;height: 1.852vw;"
                on:click={() => {
                    bntFun();
                }}
            >
                <img
                    src="images/fundamental_programs/next_button.svg"
                    alt=""
                    width="100%"
                    style="transform: scaleX(-1);"
                />
            </div>
        </div>
    </div>
</section>

<style>
    .start {
        transform: translate(0vw);
        opacity: 1;
    }
    .start-slide {
        transform: translate(-59.5vw);
        opacity: 1;
    }
    .border-div {
        width: 45.675vw;
        height: 30.82vw;
        margin-left: 27vw;
        margin-top: 4.233vw;
        border: 0.198vw solid #7cc1ff;
        border-right: none;        
    }
    .hero-div {
        width: 24.008vw;
        height: 15.41vw;
        background: linear-gradient(285.51deg, #3382c0 0%, #66bafb 99.38%);
        top: 0vw;
        left: 5.423vw;
        border-radius: 2vw 0vw 0vw 0vw;
        border: 0.198vw solid #7cc1ff;
        position: absolute;
    }
    .raised-div {
        width: 24.008vw;
        height: 15.41vw;
        background: linear-gradient(74.12deg, #00204b 1.5%, #00429b 99.49%);
        top: 15.4vw;
        left: 5.423vw;
        border-radius: 0vw 0vw 0vw 2vw;
        border: 0.198vw solid #7cc1ff;
        border-top: none;
        position: absolute;
    }
    .hero-text {
        font-size: 1.653vw;
        margin-top: 6.746vw;
        text-align: center;
        font-weight: 600;
        color: white;
    }
    .sli {
        scroll-snap-align: start;
        transition: transform 1s, opacity 2s;
    }
    .slider-img {
        height: 6.283vw;
    }
    .slider-img img {
        width: 100%;
        height: 100%;
    }
    .name-text {
        font-size: 1.19vw;
        font-weight: 500;
        width: 13vw;
        line-height: 1.7vw;
    }
    .data-part {
        margin-top: 2.183vw;
        justify-content: space-between;
    }
    .logo-text {
        font-size: 0.926vw;
        color: #3c74c0;
        line-height: 1.2vw;
        margin-right: 1vw;
    }
    .slider::-webkit-scrollbar {
        display: none;
    }
    .name-text,
    .logo-text,
    p {
        margin-bottom: 0vw;
    }
    .slider {
        display: flex;
        margin-top: -22vw;
        width: 60vw;
        height: 12.82vw;
        margin-left: 38vw;
        scroll-behavior: smooth;
        overflow: hidden;
        gap: 5.5vw;
    }
</style>
